import Crud from '../components/Worktime/Crud'


let routes = {
    path: '/worktime',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/worktime',
            name: 'Jornada de Trabalho',
            component: Crud
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/worktime.js